export default __webpack_public_path__ + "static/media/HeroSwatch.a44a7945.png";